export const stringArray = (arrayToString) => {
  if (Array.isArray(arrayToString)) {
    return arrayToString.join(', ');
  } else {
    return null;
  }
};
